export const OWNERS_TYPE_OPTIONS = Object.freeze({
  FOUNDER: 'founder',
  OWNER: 'owner',
  AUTHORIZED: 'authorized',
});

export const COMPANY_TYPE_OPTIONS = Object.freeze([
  {
    value: 'main',
    label: 'main',
  },
  {
    value: 'branch',
    label: 'branch',
  },
]);

export const MARKET_OPTIONS = Object.freeze([
  {
    value: 'RS',
    label: 'market.RS',
  },
  {
    value: 'AL',
    label: 'market.AL',
  },
  {
    value: 'PL',
    label: 'market.PL',
  },
]);

export const HR_DOCUMENTS_OPTIONS = Object.freeze([
  // RS market
  {
    value: 'serbian',
    label: 'serbian',
    markets: ['RS'],
  },
  {
    value: 'bilingual',
    label: 'bilingual',
    markets: ['RS'],
  },
  {
    value: 'serbianRussian',
    label: 'serbianRussian',
    markets: ['RS'],
  },
  {
    value: 'serbianAlbanian',
    label: 'serbianAlbanian',
    markets: ['RS'],
  },
  {
    value: 'serbianPolish',
    label: 'serbianPolish',
    markets: ['RS'],
  },
  // AL market
  {
    value: 'albanian',
    label: 'albanian',
    markets: ['AL'],
  },
  {
    value: 'albanianEnglish',
    label: 'albanianEnglish',
    markets: ['AL'],
  },
  {
    value: 'albanianSerbian',
    label: 'albanianSerbian',
    markets: ['AL'],
  },
  // PL market
  {
    value: 'polish',
    label: 'polish',
    markets: ['PL'],
  },
  {
    value: 'polishEnglish',
    label: 'polishEnglish',
    markets: ['PL'],
  },
  {
    value: 'polishSerbian',
    label: 'polishSerbian',
    markets: ['PL'],
  },
]);

export const HR_DOCUMENTS_TYPES_OPTIONS = Object.freeze([
  {
    value: 'pdf',
    label: 'pdf',
  },
  {
    value: 'doc',
    label: 'word',
  },
]);

export const SEPARATED_REQUEST_DOCS_OPTIONS = Object.freeze([
  {
    value: 'regular',
    label: 'regular',
  },
  {
    value: 'separated',
    label: 'separated',
  },
]);

export const WORK_TYPES_OPTIONS = Object.freeze([
  {
    value: '1',
    label: '1',
  },
  {
    label: '2',
    value: '2',
  },
  {
    label: 'none',
    value: 'none',
  },
]);

export const SALARY_CALCULATION_OPTIONS = Object.freeze([
  {
    value: 'average',
    label: 'average',
  },
  {
    value: 'fixed',
    label: 'fixed',
  },
]);

export const CALCULATION_METHOD_OPTIONS = Object.freeze([
  {
    value: 'automatic',
    label: 'automatic',
  },
  {
    value: 'manual',
    label: 'manual',
  },
  {
    value: 'monthlyFee',
    label: 'monthlyFee',
  },
  {
    value: 'minimumDays',
    label: 'minimumDays',
  },
  {
    value: 'fixed',
    label: 'fixedMonthly',
  },
  {
    value: 'perDay',
    label: 'perDay',
  },
  {
    value: 'perDayHoliday',
    label: 'perDayHoliday',
  },
]);

export const USER_TYPES_OPTIONS = Object.freeze([
  {
    key: 'founder',
    label: 'founder',
    color: 'purple',
  },
  {
    key: 'owner',
    label: 'owner',
    color: 'blue',
  },
  {
    key: 'authorized',
    label: 'authorized',
    color: 'green',
  },
]);

export const CALCULATION_METHOD_BY_TYPE_OPTIONS = Object.freeze({
  meal: ['automatic', 'manual', 'monthlyFee', 'perDay'],
  holiday: ['automatic', 'manual', 'perDayHoliday', 'monthlyFee'],
  travel: [
    'automatic',
    'manual',
    'fixed',
    'minimumDays',
    'perDay',
    'monthlyFee',
  ],
  workFromHome: ['automatic', 'manual', 'fixed', 'monthlyFee'],
});
